import React from 'react';
import SiteLogo, { SiteLogoVariant } from './SiteLogo';

export const SITE_BRAND_TAGLINE = 'Connecting Tech Talent';

type SiteBrandProps = {
  markSize?: number;
  showWordmark?: boolean;
  showTagline?: boolean;
  layout?: 'horizontal' | 'stacked';
  className?: string;
  wordmarkClassName?: string;
  markClassName?: string;
  variant?: SiteLogoVariant;
};

/**
 * Platform mark used on auth and chrome surfaces.
 *
 * Example: horizontal brand with tagline under the wordmark.
 * ```tsx
 * <SiteBrand markSize={40} />
 * ```
 */
const SiteBrand: React.FC<SiteBrandProps> = ({
  markSize = 40,
  showWordmark = true,
  showTagline = true,
  layout = 'horizontal',
  className = '',
  wordmarkClassName = '',
  markClassName = '',
  variant = 'default',
}) => {
  const layoutClass =
    layout === 'stacked'
      ? 'site-brand--stacked flex flex-col items-center gap-2'
      : 'flex items-center gap-3';

  return (
    <div
      className={`site-brand ${layoutClass} ${className}`.trim()}
      role="img"
      aria-label={
        showTagline
          ? 'Jobs and Opportunities — Connecting Tech Talent'
          : 'Jobs and Opportunities'
      }
    >
      <SiteLogo
        size={markSize}
        className={`site-brand-mark ${markClassName}`.trim()}
        variant={variant}
      />
      {showWordmark ? (
        <span className={`site-brand-wordmark ${wordmarkClassName}`.trim()}>
          <span className="site-brand-wordmark-title">
            Jobs <span className="site-brand-wordmark-amp">&</span> Opportunities
          </span>
          {showTagline ? (
            <span className="site-brand-tagline">{SITE_BRAND_TAGLINE}</span>
          ) : null}
        </span>
      ) : null}
    </div>
  );
};

export default SiteBrand;
